import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { OfferFormView } from "../features/offers/offer-form";
import { Require } from "../features/require";

/** A new offer (P9-T09). */
export const Route = createFileRoute("/more/offers/new")({ component: Page });

function Page() {
	const navigate = useNavigate();
	const done = () => void navigate({ to: "/more/offers" });
	return (
		<Require permission="offers.manage">
			<OfferFormView offerId={null} onSaved={done} onDeleted={done} />
		</Require>
	);
}
